import type { ApplicationEnvActions } from 'redux/actions/appEnv';

import { getEnvVar } from 'utility/env';
import { SET_APP_ENVIRONMENT } from 'redux/actions/appEnv';

export type ApplicationEnvInitialState = {
  envTarget: string;
  applicationVersion: string;
  commitHash: string;
  buildTimestamp: string;
};

const applicationEnvInitialState: ApplicationEnvInitialState = {
  envTarget: getEnvVar('ENVIRONMENT') || 'development',
  applicationVersion: getEnvVar('APPLICATION_VERSION') || 'error',
  commitHash: getEnvVar('GIT_SHORT_HASH') || 'error',
  buildTimestamp: getEnvVar('BUILD_TIMESTAMP') || 'error',
};

export default function reducer(
  state: ApplicationEnvInitialState = applicationEnvInitialState,
  action: ApplicationEnvActions,
): ApplicationEnvInitialState {
  switch (action.type) {
    case SET_APP_ENVIRONMENT:
      return { ...state, envTarget: action.payload };
    default:
      return state;
  }
}
